import { Undefinedable, cclFetch, createInternalAppError } from 'gocclr-shared-ui/dist/helpers'
import { getAppState } from '../hooks/app-state';
import { getFooterUrl, getUser } from '../app-context/accounts-context';
import DOMPurify from 'dompurify';

interface GoCCLPortalUIAppModule {
    init(): void;
}

interface GoCCLPortalUIApp {
    footer?: GoCCLPortalUIAppModule;
}

interface GoCCLPortalWindow extends Window {
    APP?: GoCCLPortalUIApp;
}

const parser = new DOMParser();
let currentPromise: Undefinedable<Promise<string>> = undefined;

function getRawFooter(headerUrl: string): Promise<string> {
    if (currentPromise) {
        return currentPromise;
    }

    currentPromise = cclFetch<string>(headerUrl, { credentials: 'include' }).then((response) => {
        return DOMPurify.sanitize(response);
    });
    return currentPromise;
}

export async function getFooterHtml(): Promise<string> {
    const rawFooter = getAppState('rawFooter');
    if (rawFooter) {
        return Promise.resolve(rawFooter);
    }

    const user = getUser();
    const footerUrl = getFooterUrl(!!user);
    const rawHtml = await getRawFooter(footerUrl);
    const parsedDoc = parser.parseFromString(rawHtml, 'text/html');
    const errorNode = parsedDoc.querySelector('parsererror');
    if (errorNode) {
        throw createInternalAppError('Could not parse the header response');
    }
    const footerWrap = parsedDoc.querySelector('#ccl-footer');
    const footerHtml = footerWrap?.outerHTML || '';
    currentPromise = undefined;

    return footerHtml;
}

export function initFooter() {
    const interval = setInterval(() => {
        if (!document.getElementById('ccl-headerWrap') || !document.getElementById('ccl-headerWrap')) {
            return;
        }

        clearInterval(interval);

        const portalWindow: GoCCLPortalWindow = window;
        portalWindow.APP?.footer?.init();
    }, 100);
}

export function clearFooterPromise() {
    currentPromise = undefined;
}